module.exports = __webpack_public_path__ + "static/image-04-a@2x-86c9850686a64f272ca3016cb5afd28e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-04-a@2x.jpg
// module id = 359
// module chunks = 3627797113349 20562973939449 33019919093843